/**
 * Returns the number of decimals to the right of the decimal point in a number or number-as-string
 * @param value
 */
export var countDecimals = function (value) {
    var stringValue = typeof value === 'number' ? value.toString() : value;
    if (stringValue.indexOf('.') === -1)
        return 0;
    var decimalValue = stringValue.split('.')[1];
    return decimalValue.length;
};
//# sourceMappingURL=countDecimals.js.map